module.exports = "pegasus_template/assets/blocks/tile-layout-02.png";